<template>
  <svg class="plus-icon" xmlns="http://www.w3.org/2000/svg" width="18" height="18" viewBox="0 0 18 18" fill="none">
    <path d="M9 0V18M0 9H18" stroke="#1C6979" stroke-width="2" stroke-miterlimit="10" />
  </svg>
</template>
